export default {
  // Navigation
  nav: {
    login: 'Login',
    getStarted: 'Get Started',
    pricing: 'Pricing',
    howItWorks: 'How it works',
    joinWaitlist: 'Join Waitlist'
  },

  // Theme
  theme: {
    switchToLight: 'Switch to light mode',
    switchToDark: 'Switch to dark mode'
  },

  // Burger Menu

  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    remove: 'Remove',
    edit: 'Edit',
    change: 'Change',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    selectAll: 'Select All',
    processing: 'Processing...',
    characters: 'characters',
    retry: 'Retry',
    noImage: 'No image',
    videoNotSupported: 'Your browser does not support the video tag.',
    created: 'Created',
    saving: 'Saving...',
    saveChanges: 'Save Changes',
    create: 'Create',
    creating: 'Creating...',
    upload: 'Upload',
    uploading: 'Uploading...',
    sending: 'Sending...',
    test: 'Test',
    or: 'or',
    generatingContent: 'Generating content...',
    justNow: 'Just now',
    minuteAgo: 'minute ago',
    minutesAgo: 'minutes ago',
    pagination: {
      previous: '← Previous',
      next: 'Next →',
      pageInfo: 'Page {current} of {total} ({count} total)'
    },
    theme: 'Theme',
    language: 'Language',
    allRightsReserved: 'All rights reserved.',
    dashboard: 'Dashboard',
  },

  // Platforms
  platforms: {
    facebook: 'Facebook',
    instagram: 'Instagram',
    tiktok: 'TikTok',
    twitter: 'Twitter/X',
    linkedin: 'LinkedIn',
    pinterest: 'Pinterest',
    facebookWithIcon: 'Facebook',
    instagramWithIcon: 'Instagram',
    tiktokWithIcon: 'TikTok',
    twitterWithIcon: 'Twitter/X',
    linkedinWithIcon: 'LinkedIn',
    pinterestWithIcon: 'Pinterest'
  },

  // Timezones

  // Auth / Login View
  auth: {
    brandSubtitle: 'AI-Powered Content for Your Brand',
    email: 'Email',
    emailPlaceholder: "your{'@'}email.com",
    signIn: 'Sign In',
    backToLogin: 'Back to Login',
    continueWithApple: 'Continue with Apple',
    continueWithGoogle: 'Continue with Google',
    continueWithFacebook: 'Continue with Facebook',
    signInWithEmail: 'Sign in with email',
    checkEmailForLink: 'Check your email for a login link',
    emailConfirmed: 'Success! Loading your profile...',
    pleaseLogin: 'Please sign in to continue',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    lastUsed: 'Last used'
  },

  // Waitlist Landing Page
  waitlist: {
    headline: "Your brand's automated social media manager",
    subheadline:
      "Create stunning content, schedule posts, and grow your brand's presence—all with AI.",
    emailPlaceholder: 'Enter your email',
    joinButton: 'Join the Waitlist',
    joining: 'Joining...',
    successTitle: "You're on the list!",
    successMessage: "We'll notify you when Social Chef launches.",
    alreadyOnList: 'This email is already on the waitlist',
    invalidEmail: 'Please enter a valid email address',
    error: 'Something went wrong. Please try again.',
    loginLink: 'Already have an account?',
    loginLinkText: 'Sign in',
    socialProof: 'Join {count}+ brands on the waitlist',
    finalCta: {
      title: 'Be the First to Know',
      subtitle: 'Join the waitlist and get early access when we launch.'
    }
  },

  // Landing Page
  landing: {
    // Hero Section
    hero: {
      tagline: 'AI-Powered Social Media for Your Brand',
      headlinePart1: 'The most powerful &',
      headlinePart2: 'effortless AI content',
      headlinePart3: 'generator for your brand',
      headlinePart3Bars: 'generator for bars',
      headlinePart3Yachts: 'generator for yachts',
      headlinePart3Hotels: 'generator for hotels',
      subheadline: 'Get stunning social media posts that publish themselves. No photographer, no designer, no tech skills needed.',
      cta: 'Get started now',
      ctaSecondary: 'See how it works',
      seenOn: 'As seen on:',
      features: {
        images: 'Generate images',
        videos: 'Create videos',
        posts: 'Write posts',
        publish: 'Auto-publish',
        analytics: 'Track analytics'
      }
    },

    // Login Box (inline in hero)
    loginBox: {
      goToDashboard: 'Go to Dashboard'
    },

    // How It Works Showcase Section
    examples: {
      title: 'How It Works',
      subtitle: 'From your phone to professional posts in seconds',
      originalPhoto: 'Your Photo',
      originalLabel: 'Original',
      aiGenerated: 'SocialChef Enhanced',
      flow: {
        step1Title: 'Upload Your Photo',
        step1Description: 'Snap a photo of your business with your phone. No professional camera needed.',
        step2Title: 'SocialChef Creates Multiple Versions',
        step2Description: 'SocialChef generates beautiful variations in different styles, each with engaging captions.',
        step3Title: 'Approve & Publish',
        step3Description: 'Choose your favorite version and it gets published automatically to Facebook and Instagram.'
      },
      gallery: {
        before: 'Before',
        after: 'After'
      },
      templates: {
        behindTheScenes: 'Behind the Scenes',
        studioShot: 'Studio Shot',
        oneBite: 'One Bite',
        zoomIn: 'Zoom In',
        cleanStrict: 'Clean Strict',
        infographic: 'Infographic',
        custom: 'Custom',
        andMore: 'And many more...'
      }
    },

    // Auto-Posting Feature (KEY DIFFERENTIATOR)
    autoPosting: {
      badge: 'Key Feature',
      title: 'Set It & Forget It',
      headline: 'Your posts publish automatically. Really.',
      description: "No more remembering to post. No more logging into apps. SocialChef handles everything - from creation to publishing. You'll look like you have a dedicated social media manager.",
      feature1: 'Posts go live while you work',
      feature2: 'Works with Instagram & Facebook',
      feature3: 'Schedule weeks in advance'
    },

    // Benefits
    benefits: {
      title: 'Why Brand Owners Love SocialChef',
      time: {
        title: 'Save Countless Hours Per Week',
        description: 'Stop wrestling with content creation. Spend that time on what matters - your business and customers.'
      },
      professional: {
        title: 'Always Look Professional',
        description:
          'Every post looks like it was made by a pro designer. Because it was. An AI one.'
      },
      growth: {
        title: 'Grow Your Following',
        description:
          'Consistent posting means more engagement. More engagement means more customers.'
      },
      easy: {
        title: 'No Tech Skills Needed',
        description:
          "If you can take a photo, you can use SocialChef. That's it."
      }
    },

    // Social Proof

    // Pricing Preview
    pricing: {
      title: 'Simple, Honest Pricing',
      subtitle: 'Start today. Cancel anytime.'
    },

    // Final CTA
    finalCta: {
      title: 'Ready to Fire Your Social Media Worries?',
      subtitle: 'Join hundreds of brand owners who stopped stressing about social media.'
    },

    // Login Modal
    loginModal: {
      title: "Let's Get Started",
      subtitle: 'Sign in to generate your first post'
    },

    // Paywall Modal
    paywall: {
      title: 'Choose Your Plan',
      subtitle: 'Unlock automatic posting and save hours every week',
      autoPostingReminder: 'All plans include automatic posting to Instagram & Facebook'
    },

    // Footer
    footer: {
      madeWith: 'Made with love for brand owners',
      copyright: '© 2025 SocialChef. All rights reserved.'
    }
  },

  // Dashboard View
  dashboard: {
    welcomeBack: 'Welcome, {name}!',

    // Welcome Modal
    welcomeModalTitle: 'Welcome to SocialChef!',
    welcomeModalMessage:
      "Looks like you haven't added a brand yet. Let's get started by adding your first brand and creating some amazing content!",
    welcomeModalButton: "Let's Go",

    // Stats
    postsCreated: 'Posts Created',
    postsSaved: 'Posts Saved',
    scheduledPosts: 'Scheduled Posts',
    restaurants: 'Brands',

    // Quick actions

    // Social platforms

    // Platform descriptions

    // Connection status
    connect: 'Connect',

    // Account overview
  },

  // Plans View
  plans: {
    brandTitle: 'SocialChef',
    chooseYourPlan: 'Choose Your Plan',
    unlockPower: 'Unlock the full power of AI-generated content',
    loading: 'Loading plans...',
    mostPopular: 'Most Popular',
    bestValue: 'Best Value',
    currentPlan: 'Current Plan',
    manageSubscription: 'Manage Subscription',
    perMonth: '/month',
    perYear: '/year',
    equalsMonthly: 'only {price}/month',
    oneTime: 'one-time',
    failedToLoad: 'Failed to load plans',
    failedToOpenPortal: 'Failed to open billing portal',
    failedToCheckout: 'Failed to create checkout',
    networkError: 'Network error',
    subscriptionSuccess: 'Subscription successful! Your account will be updated shortly.',
    subscriptionCanceled: 'Subscription canceled',
    // Trust section
    securePayment: 'Secure payment via Stripe',
    cancelAnytime: 'Cancel anytime',
    prioritySupport: 'Priority support',
    // New pricing tier keys
    creditsUpfront: 'credits upfront',
    creditsTotal: 'credits total',
    images: 'images',
    videos: 'videos',
    orEquivalent: 'or',
    limitedTo: 'Limited to {count} people',
    launchDeal: 'Launch Deal',
    getStarted: 'Subscribe',
    upgrade: 'Upgrade',
    buy: 'Buy',
    promoCodeHint: 'Have a promo code? Enter it at checkout.',
    referralDiscountApplied: 'Your referral discount will be applied automatically at checkout!',
    imageGeneration: 'AI image generation',
    videoGeneration: 'AI video generation',
    facebookPublishing: 'Facebook posting',
    instagramPublishing: 'Instagram posting',
    included: 'Included',
    postScheduling: 'Post scheduling',
    unlimitedRestaurants: 'Unlimited brands',
    noExpiration: 'Credits never expire',
    subscriptionRequired: 'A subscription is required to access SocialChef. Choose a plan below to get started.',
    // Processing states
    activatingSubscription: 'Activating Your Subscription',
    paymentReceived: 'Payment received',
    settingUpAccount: 'Setting up your account',
    almostReady: 'Almost ready!',
    processingHint: 'This usually takes just a few seconds...',
    // Success
    subscriptionActivated: 'Subscription activated successfully!',
    // Error/Timeout states
    activationDelayed: 'Taking Longer Than Expected',
    activationTakingLong: 'Your payment was successful, but account activation is taking longer than usual. Your subscription will be active shortly.',
    checkLater: 'Go to Dashboard',
    contactSupport: 'If this persists, please contact support at support@socialchef.ai'
  },

  // Restaurant Search View
  restaurantSearch: {
    searchPlaceholder: 'Search brands by name or location...',
    noResults: 'No brands found',

    // Autocomplete
    searchLabel: 'Search Brands',
    searching: 'Searching...',
    searchError: 'Failed to search brands. Please try again.',
    alreadyAdded: 'Already Added',

    // Quick Overview

    // Opening Hours

    // Contact & Info

    // Photos

    // Image Upload

    // Social Media

    // Brand Identity

    // Customer Reviews

    // Competitors

    // Menu

    // Actions

    // Messages

    // Progress Modal
  },

  // Onboarding
  onboarding: {
    // Tour steps
    tour: {
      welcomeDetails: [
        'Create stunning social media posts in seconds',
        'AI-powered content generation tailored to your brand',
        'Save time while maintaining consistent quality',
        'Schedule posts and manage multiple platforms',
      ],

      searchDetails: [
        'Search brands using Google Places',
        'Automatically import menus, photos, and brand details',
        'Build your brand database',
        'Access comprehensive brand information',
      ],

      createDetails: [
        'Generate images and videos with AI',
        'Create compelling captions and hashtags',
        'Customize with your brand identity',
        'All generated content is automatically saved',
      ],

      scheduleDetails: [
        'Schedule posts in advance',
        'Publish directly to Facebook',
        'Manage multiple brands',
        'Track your content performance',
      ],

      connectDetails: [
        'Connect Facebook, Instagram, TikTok, and more',
        'Post directly from our platform',
        'Manage all your accounts in one place',
        'Secure OAuth authentication',
      ],

      readyDetails: [
        'Start by adding your brand',
        'Generate your first post in minutes',
        'All content is saved to your library',
        'Schedule content to maintain consistency',
      ],

      // Navigation
    },

    // Quiz
    quiz: {

      // Questions
      q1Options: [
        'Connect social media accounts',
        'Search and save a brand',
        'Generate AI content',
        'Schedule posts',
      ],

      q2Options: [
        'Image generation only',
        'Caption writing only',
        'Images, videos, and captions',
        'Menu design only',
      ],

      q3Options: [
        'Manual entry only',
        'Google Places and delivery platforms',
        'Social media only',
        'Custom databases',
      ],

      q4Options: [
        'Download only',
        'Schedule only',
        'Save, schedule, and publish to Facebook',
        'Email only',
      ]
    },

    // Simple onboarding flow
    simple: {
      // Stepper labels
      // Platform descriptions
      // Publish step
      // Completion modal
      // Navigation buttons
    }
  },

  // Playground View
  playground: {
    chooseRestaurant: 'Choose a Brand',
    addNewRestaurant: '+ Add New Brand',
    menuItems: 'menu items',
    saved: 'Saved',
    livePreview: 'Live Preview',
    yourGeneratedImage: 'Your Generated Image',
    previewDescription: 'Preview how your sticker and logo will appear',
    itemsSelected: '{count} item selected | {count} items selected',
    selectRestaurant: 'Select Brand',

    // Tabs

    // AI Prompts
    generatingIdeas: 'Generating creative ideas with AI...',
    aiGeneratedIdeas: 'AI-Generated Ideas',
    getNewIdeas: 'Get New Ideas',
    selectedBadge: 'Selected',

    // Image Generation

    // Post Content
    postContentTitle: 'Post Content',

    // Video Generation

    // Restaurant Details Modal

    // Style Templates (Easy Mode)
    styleTemplates: {
      behindTheScenes: {
        name: 'Behind the Scenes',
        description: 'Authentic kitchen moment',
        preview: 'Documentary-style cooking process (works for images & videos)'
      },
      cleanStrict: {
        name: 'Clean Strict',
        description: 'Professional studio quality',
        preview: 'Clean surface, cinematic lighting (works for images & videos)'
      },
      zoomIn: {
        name: 'Zoom In',
        description: 'Extreme macro close-up',
        preview: 'Texture details, ASMR-quality (works for images & videos)'
      },
      oneBite: {
        name: 'One Bite',
        description: 'Ready-to-eat presentation',
        preview: 'Satisfying bite reveal (works for images & videos)'
      },
      studioShot: {
        name: 'Studio Shot',
        description: 'Professional advertisement look',
        preview: '360-degree orbit, premium quality (works for images & videos)'
      },
      infographic: {
        name: 'Infographic',
        description: 'Deconstructed ingredients view',
        preview: 'Ingredient assembly or labeled layout (works for images & videos)'
      },
      placeOnTable: {
        name: 'Place on Table',
        description: 'Dish being served',
        preview: 'Hands placing dish on table, creates anticipation (VIDEO ONLY)'
      },
      custom: {
        name: 'Custom',
        description: 'Write your own prompt',
        preview: 'Full creative control (works for images & videos)'
      }
    },

    // Additional messages
  },

  // Easy Mode Creation
  easyMode: {
    steps: {
      menu: 'Menu',
      customize: 'Customize',
      preview: 'Preview',
      publish: 'Publish'
    },
    step1: {
      title: 'Pick Your Dish or Upload Image',
      subtitle: 'Choose a menu item or upload your own image',
      description:
        'An image is required to create your post. Select a dish from your menu or upload your own photo.',
      empty: 'No menu items available. Upload an image to continue.',
      imageRequired: 'Please select a menu item or upload an image to continue',
      nextButton: 'Customize Post'
    },
    step2: {
      title: 'Customize Your Post',
      subtitle: 'Choose style, add promotions, and branding',
      styleLabel: 'Visual Style',
      customPromptPlaceholder: 'Describe how you want your dish photographed...',
      mediaTypeLabel: 'Media Type',
      imageOption: 'Image',
      videoOption: 'Video',
      imageCredits: '1 credit',
      videoCredits: '5 credits',
      videoOptionsLabel: 'Video Settings',
      durationLabel: 'Duration',
      durationWarning: 'Longer videos take more time to generate and may fail during high demand.',
      seconds: 's',
      aspectRatioLabel: 'Aspect Ratio',
      portrait: 'Portrait',
      landscape: 'Landscape',
      includeAudio: 'Include AI-generated audio',
      promoLabel: 'Special Offer (Optional)',
      promoPlaceholder: 'e.g., 20% OFF, COMBO DEAL, NEW ITEM...',
      logoLabel: 'Brand Logo',
      currentLogo: 'Current logo',
      newLogo: 'New logo',
      uploadLogo: 'Upload logo',
      changeLogo: 'Change logo',
      removeLogo: 'Remove uploaded logo',
      includeLogo: 'Include logo on image',
      generateButton: 'Generate Image',
      generateVideoButton: 'Generate Video',
      outOfCredits: 'You are out of credits. Please upgrade your plan to generate more content.'
    },
    upload: {
      button: 'Upload Your Own Image',
      hint: 'JPG, PNG, or WebP'
    },
    step3: {
      title: 'Preview Your Post',
      subtitle: 'Review and edit your generated content',
      editPostText: 'Edit your post text',
      addHashtagPlaceholder: 'Type hashtag and press Enter',
      animateImage: 'Animate Image',
      animateCredits: '5 credits',
      animationOptionsTitle: 'Video Animation Settings',
      generateVideoFromImage: 'Generate Video',
      generateVideoCredits: '5 credits',
      showImage: 'Image',
      showVideo: 'Video',
      animatingImage: 'Creating video animation...',
      insufficientCredits: 'You need at least 5 credits to animate this image',
      noImageToAnimate: 'No image available to animate',
      audioDisabledNote: 'Audio disabled for cleaner results',
      videoGeneratingTitle: 'Video generating in background...',
      videoGeneratingSubtitle: 'You can post the image now. Video will be ready soon.',
      videoGeneratingNote: 'Video is generating. Save your post to track progress.'
    },
    step4: {
      title: 'Choose Platform & Schedule',
      subtitle: 'Select where and when to publish',
      successTitle: 'Congratulations!',
      successMessage: 'Your post has been published successfully!',
      viewOnPlatform: 'View on {platform}',
      partialFailureWarning: 'Some platforms failed to publish:',
      createAnother: 'Create Another Post'
    }
  },

  // Advanced Mode Creation
  advancedMode: {
    steps: {
      menuSelection: 'Menu Items',
      customize: 'Customize',
      styleSelection: 'Style',
      preview: 'Preview',
      publish: 'Publish'
    },
    step1: {
      title: 'Select Menu Items',
      subtitleSingle: 'Select 1 menu item to highlight',
      subtitleCombo: 'Select 2 items for your combo offer',
      subtitleWeekly: 'Assign a dish to each day of the week',
      itemsSelected: '{count} of {max} items selected',
      noItems: 'No menu items available',
      uploadTitle: 'Upload Your Own Image',
      uploadButton: 'Upload Image',
      uploadHint: 'JPG, PNG, or WebP',
      orDivider: 'OR select from menu'
    },
    postType: {
      title: 'What type of post do you want to create?',
      single: {
        title: 'Single Item',
        description: 'Highlight one dish with a focused image'
      },
      combo: {
        title: 'Combo Post',
        description: 'Showcase 2 items as a special offer or bundle'
      },
      weekly: {
        title: 'Weekly Menu',
        description: 'Create a menu featuring dishes for each day'
      },
      weekLengthLabel: 'How many days?',
      fiveDays: '5 days (Mon-Fri)',
      sevenDays: '7 days (Mon-Sun)',
      includePrices: 'Include prices in image',
      assignDishes: 'Assign a dish to each day',
      selectDish: 'Select dish...',
      selectDishFor: 'Select dish for {day}',
      enterPrice: 'Enter price',
      of: 'of',
      dishesSelected: 'dishes selected',
      days: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday'
      }
    },
    step2: {
      title: 'Customize Your Design',
      subtitle: 'Tailor the look and feel of your post',
      logoPositionLabel: 'Brand Logo Position',
      logoPositionHint: 'Where to place your brand logo',
      previewLabel: 'Preview'
    },
    logoPositions: {
      topLeft: 'Top Left',
      topRight: 'Top Right',
      bottomLeft: 'Bottom Left',
      bottomRight: 'Bottom Right',
      center: 'Center',
      none: 'No Logo'
    },
    fonts: {
      playfair: 'Playfair Display (Elegant)',
      inter: 'Inter (Modern)',
      montserrat: 'Montserrat (Bold)',
      lora: 'Lora (Classic)',
      roboto: 'Roboto (Clean)'
    },
    step3: {
      title: 'Choose Your Style',
      subtitle: 'Select from AI-generated style variations',
      generatingTitle: 'Crafting your styles',
      generatingSubtitle: 'Our AI is creating unique design options for you',
      selectStyle: 'Select a style to continue',
      selectedStyle: 'Selected Style',
      editPrompt: 'Edit Prompt',
      promptLabel: 'AI Prompt (Editable)',
      promptPlaceholder: 'Describe how you want your image to look...',
      regenerate: 'Regenerate Styles',
      outOfCredits: 'You are out of credits. Please upgrade your plan to generate more content.'
    },
    styleVariations: {
    },
    strictness: {
      label: 'Image Style',
      hint: 'How closely should the result match the original?',
      strict: 'Strict',
      strictDesc: 'Stay true to original - better plating and lighting only',
      flexible: 'Flexible',
      flexibleDesc: 'Elevated presentation with creative touches',
      creative: 'Creative',
      creativeDesc: 'Artistic reimagining with extras and garnishes'
    },
    holidayTheme: {
      label: 'Theme / Inspiration',
      hint: 'Add a seasonal or themed style to your image',
      customPlaceholder: 'Enter your custom theme...'
    },
    comboOptions: {
      textPlacement: 'Text Placement',
      textPlacementHint: 'Where to display combo text',
      top: 'Top Overlay',
      bottom: 'Bottom Overlay',
      side: 'Side Panel',
      noText: 'No Text',
      itemArrangement: 'Item Arrangement',
      itemArrangementHint: 'How items appear together',
      sideBySide: 'Side by Side',
      stacked: 'Stacked',
      overlapping: 'Overlapping',
      diagonal: 'Diagonal'
    },
    preview: {
      title: 'Preview',
      placeholder: 'Your post preview will appear here'
    },
    step4: {
      title: 'Preview Your Post',
      subtitle: 'Review and edit your generated content',
      editPostText: 'Edit your post text',
      addHashtagPlaceholder: 'Type hashtag and press Enter',
      nextButton: 'Continue to Publish'
    },
    step5: {
      title: 'Generate Your Image',
      subtitle: 'Create your custom post image',
      imagePreview: 'Image Preview',
      postTextLabel: 'Post Text',
      postTextPlaceholder: 'Write your post caption...',
      hashtagsLabel: 'Hashtags',
      addHashtag: 'Add hashtag...'
    },
    publish: {
      publishingTitle: 'Sharing your post',
      publishingSubtitle: 'Uploading to your social accounts',
      error: 'Failed to publish. Please try again.',
      retrying: 'Retrying ({attempt}/{max})...',
      retryFailedPlatforms: 'Retry Failed Platforms'
    },
    navigation: {
      back: '← Back',
      next: 'Next →',
      generate: 'Generate →'
    },
    messages: {
      styleRequired: 'Please select a style variation',
      generationError: 'Failed to generate. Please try again.',
      captionGenerationFailed: 'Caption Generation Failed',
      imageGenerationFailed: 'Image Generation Failed',
      unexpectedError: 'An unexpected error occurred. Please try again.'
    }
  },

  // Weekly Menu Customization Options
  weeklyCustomization: {
    layout: {
      title: 'Menu Layout',
      featuredGrid: 'Featured + Grid',
      featuredGridDesc: '1 large featured dish + 2x2 grid',
      calendarGrid: 'Calendar Style',
      calendarGridDesc: '5 column grid layout',
      verticalStack: 'Vertical List',
      verticalStackDesc: '5 items stacked top to bottom',
      gridWithHeader: '2x3 Grid',
      gridWithHeaderDesc: '2x3 grid with title header'
    },
    dates: {
      title: 'Date Display',
      showDates: 'Show dates on menu',
      formatFull: 'Full (December 2-6)',
      formatShort: 'Short (Dec 2-6)',
      formatDayOnly: 'Day Names Only',
      showWeekNumber: 'Show week number',
      showMonthName: 'Show month header',
      dateRange: 'Custom date range'
    },
    themes: {
      title: 'Menu Theme',
      none: 'No Theme',
      studentWeek: 'Student Week',
      christmas: 'Christmas Holiday',
      easter: 'Easter Special',
      summer: 'Summer Menu',
      valentines: "Valentine's Day",
      halloween: 'Halloween',
      thanksgiving: 'Thanksgiving',
      newYear: 'New Year',
      custom: 'Custom Text',
      customPlaceholder: 'Enter your custom theme text...'
    }
  },

  // Connect Accounts View
  connectAccounts: {
    pageTitle: 'Connect Social Media Accounts',
    pageSubtitle:
      'Connect your social media accounts to start posting content directly from our platform',
    activeBusiness: 'Active Brand',
    switchBusiness: 'Switch Brand',
    manageAll: 'Manage All',
    selectABusiness: 'Select a Brand',
    noBusinessSelected: 'No brand selected',
    selectBusinessFirst: 'Please select a brand first',
    businessCount: '{current} of {total}',
    totalConnections: 'Total Connections',
    facebookPages: 'Facebook Pages',
    facebookPagesCount: 'Facebook Pages',
    instagramBusiness: 'Instagram Business',
    instagramAccountsCount: 'Instagram Accounts',
    connectedPlatforms: 'Connected Platforms',
    platformsFor: 'Manage platform connections for {name}',
    chooseBusiness: 'Select a brand to manage connections',
    notConnected: 'Not connected',
    connect: 'Connect',
    connectMore: 'Connect More',
    disconnect: 'Disconnect',
    disconnectAll: 'Disconnect All',
    connecting: 'Connecting...',
    comingSoon: 'Coming Soon',
    accountsConnected: '{count} account connected | {count} accounts connected',
    errorOccurred: 'An error occurred. Please try again.',
    successfullyConnected: 'Successfully connected {count} account(s)!',
    successfullyConnectedFacebook: 'Successfully connected {count} Facebook page(s)!',
    successfullyConnectedInstagram: 'Successfully connected {count} Instagram account(s)!',
    successfullyConnectedTikTok: 'Successfully connected {count} TikTok account(s)!',
    successfullyConnectedTwitter: 'Successfully connected {count} Twitter account(s)!',
    successfullyConnectedLinkedIn: 'Successfully connected {count} LinkedIn page(s)!',
    successfullyDisconnected: 'Successfully disconnected "{name}"',
    successfullyDisconnectedAll: 'Successfully disconnected {count} accounts',
    confirmDisconnect: 'Are you sure you want to disconnect "{name}"?',
    confirmDisconnectAll: 'Are you sure you want to disconnect all {count} {platform} accounts?',
    disconnectTitle: 'Disconnect Account',
    disconnectAllTitle: 'Disconnect All Accounts'
  },

  // Scheduler View
  scheduler: {
    title: 'Content Scheduler',
    subtitle: 'Plan and schedule your social media posts',
    scheduledPosts: 'Scheduled Posts',
    postScheduled: 'Post scheduled successfully!',
    createPost: 'Create Post',
    moreHolidays: 'more',
    postDetails: 'Post Details',
    publishedAt: 'Published At',
    viewPost: 'View Post',
    viewOn: 'View on',
    restaurant: 'Brand',
    caption: 'Caption',
    edit: 'Edit',
    cancelPost: 'Cancel Post',
    noTime: 'No time',
    noMedia: 'No media',
    post: 'Post',
    status: 'Status',
    publishTime: 'Publish Time',
    captionGenerationFailed: 'Caption Generation Failed',
    imageGenerationFailed: 'Image Generation Failed',
    generationFailed: 'Generation Failed',
    unexpectedError: 'An unexpected error occurred. Please try again.',
    retryPost: 'Retry Post',
    retrying: 'Retrying...',
    retrySuccess: 'Post queued for retry',
    retryError: 'Failed to retry post',
    partial: 'Partially Published',
    overdue: 'Overdue'
  },

  // Edit Scheduled Post Modal
  editScheduledPost: {
    title: 'Edit Scheduled Post',
    changeImage: 'Change Image',
    selectImage: 'Select a Different Image',
    postTextPlaceholder: 'Write your post content here...',
    hashtagPlaceholder: 'Add hashtag and press Enter...',
    notConnected: 'Not connected',
    selectPlatform: 'Please select at least one platform',
    detected: 'Detected',
    notes: 'Notes (Optional)',
    notesPlaceholder: 'Add any notes about this post...',
    characters: 'characters'
  },

  // Posts View (previously Favorites)
  posts: {
    editPost: 'Edit Post',
    postText: 'Post Text',
    hashtags: 'Hashtags',
    image: 'image',
    video: 'video',
    // Additional post actions
    deleteModalTitle: 'Delete Post',
    deleteModalMessage: 'Are you sure you want to delete this post? This action cannot be undone.',
    addHashtagPlaceholder: 'Add hashtag and press Enter...',
    platformSection: 'Platform',
    saveChangesButton: 'Save Changes',
    cancelChangesButton: 'Cancel',
    publishButton: 'Publish',
    postAlt: 'Post',
    // Background video generation
    videoGenerationStarted: 'Video Generation Started',
    videoGeneratingInBackground: 'Your video is being generated in the background. You can post the image now or wait for the video.',
    videoReady: 'Video Ready',
    videoReadyToView: 'Video for "{title}" is ready to view',
    videoGenerationFailed: 'Video Generation Failed',
    create: {
      captionGenerationFailed: 'Caption Generation Failed',
      imageGenerationFailed: 'Image Generation Failed',
      videoGenerationFailed: 'Video Generation Failed',
      generationFailed: 'Generation Failed',
      unexpectedError: 'An unexpected error occurred. Please try again.',
      animationFailed: 'Animation Failed',
      animationSuccess: 'Animation Complete',
      videoGenerated: 'Video has been generated successfully'
    }
  },

  // Content Hub View
  contentHub: {
    loading: 'Loading your content...',
    yourPosts: 'Your Posts',
    noPosts: 'No posts yet',
    noPostsDescription: 'Create your first post to get started!',
    filterAll: 'All',
    sortNewest: 'Newest First',
    sortOldest: 'Oldest First',
    // Welcome state for new users
    welcomeTitle: 'Welcome!',
    welcomeSubtitle: "Let's get started by adding your first brand.",
    addFirstRestaurant: 'Add Your First Brand',
    addFirstRestaurantDescription:
      "Add your brand and we'll help you create amazing social media content.",
    noRestaurantPrompt: 'Add a brand to start creating posts.',
    addFirstBusiness: 'Add Your First Brand',
    addFirstBusinessDescription: 'Add your brand and we\'ll help you create amazing social media content.',
    manageBusinesses: 'Manage Brands',
    createPost: 'Create Post'
  },

  // Content Create View
  contentCreate: {
    loading: 'Loading...',
    loadError: 'Failed to load brand',
    switchRestaurant: 'Switch',
    imageError: 'Failed to generate image. Please try again.',
    videoError: 'Failed to generate video. Please try again.',
    videoTimeout: 'Video generation timed out. Please try again.',
    noPrompts: 'No prompts were generated',
    generateError: 'Failed to generate content',
    publishError: 'Failed to publish to Facebook',
    noFacebookPage: 'No Facebook page connected',
    facebookReconnectRequired:
      'Your Facebook connection has expired. Please reconnect to continue.',
    noPlatformSelected: 'Please select at least one platform',
    carouselMode: 'Carousel Mode',
    singleImageMode: 'Single Image',
    selectCarouselImages: 'Select 2-10 images',
    imageCount: '{current} of {max} images',
    minImagesRequired: 'Select at least 2 images for carousel',
    maxImagesExceeded: 'Maximum 10 images allowed',
    reorderHint: 'Drag images to reorder',
    uploadImages: 'Upload Images',
    dropOrClick: 'Drop images here or click to select',
    removeImage: 'Remove image',
    fromLibrary: 'From Library',
    uploadNew: 'Upload New',
    selectFromLibrary: 'Select from Library',
    librarySubtitle: 'Choose 2-10 images or videos from your saved posts',
    selectedOrder: 'Selected Order (drag to reorder)',
    noSavedMedia: 'No saved posts found',
    createPostsFirst: 'Create some posts first to use them in carousels',
    selectMoreItems: 'Select {count} more to continue',
    uploadInstructions: 'Upload 2-10 new images for your carousel',
    uploadFeatureComingSoon: 'Direct upload coming soon. For now, please use the Library tab to select from your existing posts.'
  },

  // Restaurant Selector Modal
  restaurantSelector: {
    title: 'Select Brand',
    addNew: '+ Add New Brand',
    menuItems: '{count} menu items',
    delete: 'Remove brand',
    deleteTitle: 'Remove Brand',
    confirmDelete: 'Are you sure you want to remove "{name}" from your saved brands?',
    restaurantAdded: 'Brand added successfully!',
    cantFindAddManually: "Can't find your brand? Add manually"
  },

  // Image Source Selector
  imageSourceSelector: {
    uploadNew: 'Upload New',
    browseExisting: 'Browse Existing',
    selectImage: 'Select an image',
    noImagesAvailable: 'No images available',
    folderEmpty: 'This folder is empty',
    searchPlaceholder: 'Search images...',
    selectFromStorage: 'Select from your brand images',
    uploadOrSelect: 'Upload a new image or select from your existing images'
  },

  // Profile View
  profile: {
    title: 'Profile Settings',
    subtitleExtended: 'Manage your account information and subscription',
    personalInfo: 'Personal Information',
    manageRestaurants: 'Manage Brands',
    email: 'Email',
    emailAddress: 'Email Address',
    userId: 'User ID',
    saving: 'Saving...',
    saveChanges: 'Save Changes',
    profileUpdated: 'Profile updated successfully!',
    deleteAccount: 'Delete Account',
    edit: 'Edit',
    cancel: 'Cancel',
    subscriptionAndPlan: 'Subscription & Plan',
    viewPlans: 'View Plans',
    monthlyCredits: 'Monthly Credits',
    creditsUsedThisMonth: 'Credits Used This Month',
    remainingCredits: 'Remaining Credits',
    subscriptionEnds: 'Subscription Ends',
    nextBillingDate: 'Next Billing Date',
    cancelNotice: 'Your subscription will be cancelled at the end of the current billing period.',
    upgradePlan: 'Upgrade Plan',
    cancelSubscription: 'Cancel Subscription',
    billingInformation: 'Billing Information',
    billingDescription:
      'Billing is managed through Stripe. Click below to manage your payment methods, view invoices, and update billing information.',
    manageBilling: 'Manage Billing',
    loading: 'Loading...',
    accountSecurity: 'Account Security',
    deleteAccountDanger: 'Delete Account',
    deleteAccountDescription: 'Permanently delete your account and all data',
    cancelSubscriptionTitle: 'Cancel Subscription',
    cancelSubscriptionMessage:
      "Are you sure you want to cancel your subscription? You'll still have access until the end of your current billing period.",
    keepSubscription: 'Keep Subscription',
    failedToOpenPortal: 'Failed to open billing portal',
    failedToCancelSubscription: 'Failed to cancel subscription',
    failedToUpdateProfile: 'Failed to update profile',
    notificationPreferences: 'Email Notifications',
    notifications: {
      saveSuccess: 'Notification preferences saved',
      saveError: 'Failed to save notification preferences',

      postEvents: {
        title: 'Post Activity',
        description: 'Get notified when your posts are published, fail, or are scheduled',
        published: 'Post Published',
        publishedHint: 'Receive an email when your post is successfully published to a platform',
        failed: 'Post Failed',
        failedHint: 'Get alerted immediately if a post fails to publish',
        scheduled: 'Post Scheduled',
        scheduledHint: 'Confirmation email when you schedule a post for later'
      },

      digest: {
        title: 'Activity Digest',
        description: 'Receive periodic summaries of your posting activity',
        frequency: 'Frequency',
        never: 'Never',
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
        dayOfWeek: 'Send on',
        days: {
          sunday: 'Sunday',
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday'
        }
      },

      account: {
        title: 'Account & Billing',
        description: 'Important updates about your subscription and payments',
        subscription: 'Subscription Changes',
        subscriptionHint: 'Renewals, cancellations, and plan changes',
        payment: 'Payment Issues',
        paymentHint: 'Failed payments and billing problems',
        creditsLow: 'Low Credits',
        creditsLowHint: 'Alert when you\'re running low on credits'
      },

      product: {
        title: 'Product Updates',
        description: 'Stay informed about new features and announcements',
        features: 'New Features',
        featuresHint: 'Learn about new capabilities and improvements',
        announcements: 'Company News',
        announcementsHint: 'Occasional updates from the Social Chef team'
      }
    }
  },

  // Restaurant Management
  restaurantManagement: {
    addRestaurant: 'Add Brand',
    addFirstRestaurant: 'Add Your First Brand',
    createRestaurant: 'Create Brand',
    uploadImages: 'Upload Images',
    yourImages: 'Your Images',

    noRestaurants: 'No brands yet',
    noRestaurantsHint: 'Add your first brand to get started',
    noBrandsHint: 'Add your first brand to get started',

    basicInfo: 'Basic Information',
    contactInfo: 'Contact Information',
    socialMedia: 'Social Media',
    branding: 'Branding',

    restaurantName: 'Brand Name',
    restaurantNamePlaceholder: 'e.g., My Brand',
    address: 'Address',
    addressPlaceholder: 'Enter full address',
    phoneNumber: 'Phone Number',
    phoneNumberPlaceholder: '+1 (555) 123-4567',
    website: 'Website',
    websitePlaceholder: 'https://yourbrand.com',

    instagram: 'Instagram',
    instagramPlaceholder: "{'@'}yourbrand",
    facebook: 'Facebook',
    facebookPlaceholder: 'facebook.com/yourbrand',
    twitter: 'Twitter/X',
    twitterPlaceholder: "{'@'}yourbrand",

    logoUrl: 'Logo URL',
    logoUrlPlaceholder: 'https://...',
    logoUrlHint: 'Enter a URL to your brand logo image',
    logo: 'Logo',
    dragLogoOrClick: 'Drag & drop logo here or click to browse',
    logoMaxSize: 'Maximum {size}MB (JPEG, PNG, WebP)',
    logoPreview: 'Logo preview',
    primaryColor: 'Primary Brand Color',
    secondaryColor: 'Secondary Brand Color',

    manualEntry: 'Manual',
    googlePlaces: 'Google Places',
    imagesCount: '{count} images',

    details: 'Details',
    images: 'Images',
    noImages: 'No images uploaded yet',

    deleteConfirmMessage: 'Delete "{name}"? This cannot be undone.',
    deleteImageConfirm: 'Are you sure you want to delete this image?',

    // Folder Navigation
    folderTree: 'Folders',
    allImages: 'All Images',
    createFolder: 'Create Folder',
    renameFolder: 'Rename Folder',
    deleteFolder: 'Delete Folder',
    deleteImages: 'Delete Images',
    folderName: 'Folder Name',
    folderNamePlaceholder: 'e.g., menu, burgers, desserts',
    newFolder: 'New Folder',
    rename: 'Rename',
    delete: 'Delete',

    // Folder Path
    createIn: 'Create in',
    fullPath: 'Full path',
    currentPath: 'Current path',
    newPath: 'New path',

    // Breadcrumbs & Navigation
    breadcrumbHome: 'All Images',

    // View Modes
    viewMode: 'View',
    gridView: 'Grid',
    listView: 'List',
    timelineView: 'Timeline',

    // Toolbar
    searchImages: 'Search images...',
    searchPlaceholder: 'Search by name or folder...',
    sortBy: 'Sort by',
    sortByName: 'Name',
    sortByDate: 'Upload Date',
    sortBySize: 'File Size',

    // Bulk Actions
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    selectedCount: '{count} selected',
    deleteSelected: 'Delete Selected',
    moveSelected: 'Move to Folder',
    downloadSelected: 'Download Selected',
    bulkDeleteConfirm: 'Delete {count} selected images? This cannot be undone.',
    bulkDeleteSuccess: '{count} images deleted',

    // Move Images
    moveImages: 'Move {count} Images',
    moveImagesInfo: 'Select a destination folder for {count} selected images',
    selectDestination: 'Select Destination Folder',
    movingTo: 'Moving to',
    moveCount: 'Move {count} Images',

    // Upload & Folder Actions
    uploadToFolder: 'Upload to Folder',
    selectFolder: 'Select Folder',
    currentFolder: 'Current Folder',
    newFolderName: 'New Folder Name',
    enterFolderName: 'Enter folder name',
    createNewFolder: 'Create New Folder',
    moveToFolder: 'Move to Folder',
    dragDropHint: 'Drag and drop images here, or click to browse',
    maxFilesHint: 'Maximum {max} files per upload',
    uploadingImages: 'Uploading images...',
    uploadSuccess: '{count} images uploaded successfully',
    folderCreated: 'Folder "{name}" created',
    newFolderReady: 'New folder "{name}" ready - will be created when you upload',
    folderRenamed: 'Folder renamed successfully',
    folderDeleted: 'Folder deleted successfully',
    deleteFolderConfirm: 'Delete folder "{name}" and all its contents? This cannot be undone.',

    // Empty States
    noImagesInFolder: 'No images in this folder',
    noImagesFound: 'No images found matching "{query}"',
    createFolderFirst: 'Create a folder first to organize your images',

    // Folder Errors
    folderNameRequired: 'Folder name is required',
    folderNameUnchanged: 'Please enter a different folder name',
    invalidFolderName: 'Invalid folder name. Avoid special characters like / \\ : * ? " < > |',
    chooseFolderPlaceholder: 'Choose a folder...',
    createFolderError: 'Failed to create folder',
    renameFolderError: 'Failed to rename folder',
    moveImagesError: 'Failed to move images',
    selectFolderError: 'Please select a destination folder',

    errors: {
      createFailed: 'Failed to create brand',
      uploadFailed: 'Failed to upload images',
      folderExists: 'A folder with this name already exists',
      invalidFolderName: 'Invalid folder name',
      noFilesSelected: 'Please select files to upload',
      selectFolderRequired: 'Please select a folder',
      tooManyFiles: 'Too many files selected ({count}). Maximum {max} files allowed per upload.',
      folderNotEmpty: 'Folder is not empty',
      onlyImages: 'Only image files are allowed',
      logoTooLarge: 'Logo file size must be less than {size}MB',
      logoUploadFailed: 'Failed to upload logo'
    }
  },

  // Saved Restaurants View

  // Test Post View

  // Errors
  errors: {
    generic: 'Something went wrong',
    networkError: 'Network error. Please check your connection.',
    validationError: 'Please check your input',
    timeout: 'Request timed out. Please try again.',
    httpError: 'Server error: {status}',
    publishPartial: 'Published to {success} of {total} platforms',
    retryFailed: 'Retry failed after {attempts} attempts',
    postSavedScheduleFailed: 'Post Saved, But Scheduling Failed',
    postSavedScheduleFailedMessage: 'Your post was saved to Favorites. You can schedule it later from the Posts page.'
  },

  // Alerts & Toasts
  alerts: {
  },

  // Form Validation

  // Languages
  languages: {
    selectCountry: 'Country',
    selectCurrency: 'Currency (Dev)',
  },

  // Schedule Modal
  scheduleModal: {
    title: 'Publish Post',
    preview: 'Preview',
    dateLabel: 'Date',
    timeLabel: 'Time (Optional)',
    timezoneLabel: 'Timezone',
    notesLabel: 'Notes (Optional)',
    notesPlaceholder: 'Add any notes about this scheduled post...'
  },

  // Pick Post Modal
  pickPostModal: {
    showAllRestaurants: 'Show all brands',
    showCurrentRestaurant: 'Show current brand only',
    allRestaurantsLabel: 'All Brands',
    videoLabel: 'VIDEO'
  },

  // Account Selector
  accountSelector: {
    selectAccounts: 'Select Accounts',
    selectFacebookPages: 'Select Facebook Pages',
    selectInstagramAccounts: 'Select Instagram Accounts',
    selectTikTokAccounts: 'Select TikTok Accounts',
    selectTwitterAccounts: 'Select Twitter Accounts',
    noAccountsConnected: 'No {platform} accounts connected',
    noAccountsSelected: 'Please select at least one {platform} account',
    connectAccount: 'Connect Account',
    multipleSelected: '{count} accounts selected',
    accountId: 'Account ID',
    singleAccountInfo: 'This is your only connected account. It will be used for posting.',
    postTypeLabel: 'Post Type',
    reelsRequireVideo: 'Reels require video content',
    feedShort: 'Main feed',
    feedDescription: 'Appears in followers\' feeds and on your profile. Permanent content with full engagement features.',
    storyShort: '24h temporary',
    storyDescription: 'Disappears after 24 hours. Full-screen vertical format with interactive stickers and polls.',
    reelShort: 'Short video',
    reelDescription: 'Short-form video content (15-90s). Optimized for discovery and engagement. Requires video content.',
    carouselShort: '2-10 items',
    carouselDescription: 'Click to select 2-10 images or videos in swipeable format',
    carouselRequiresImages: 'Select 2-10 images to enable carousel',
    carouselItemsSelected: '{count} items',
    carouselModalTitle: 'Select Carousel Items',
    carouselModalSubtitle: 'Choose 2-10 items and drag to reorder'
  },

  // Unified Schedule Post
  unifiedSchedule: {
    whenToPublish: 'When to Publish',
    publishNow: 'Publish Now',
    scheduleLater: 'Schedule for Later',
    selectPlatforms: 'Select Platforms',
    selectDate: 'Select Date',
    selectTime: 'Select Time',
    tapToConnect: 'Tap to connect',
    comingSoon: 'Coming Soon',
    publish: 'Publish',
    schedule: 'Schedule Post',
    noPlatformSelected: 'Please select at least one platform',
    noDateSelected: 'Please select a date',
    mustBeInFuture: 'Scheduled time must be after now',
    selectAccountsInfo: 'Choose which accounts to post to',
    publishSummary: 'Where your content will be posted',
    clickToSelectAccounts: 'Click to select accounts'
  },

  // Mode Toggle
  modeToggle: {
    easy: 'Easy',
    advanced: 'Advanced',
    easyTitle: 'Easy Mode - Quick post creation',
    advancedTitle: 'Advanced Mode - Full customization',
    confirmTitle: 'Switch Mode?',
    confirmMessage: 'You have unsaved work. Switching modes will discard your current progress.',
    switchAnyway: 'Switch Anyway'
  },

  // Confirm Modal

  // Pick Post Modal

  // Generation Result Modal

  // Publishing Progress Modal
  publishing: {
    title: 'Publishing Your Post...',
    titleWithType: 'Publishing Your {type}...',
    message: 'Please wait while we publish your post to the selected platforms.',
    messageWithType: 'Please wait while we publish your {type} to the selected platforms.',
    publishingTo: 'Publishing to {platform}...',
    publishingTypeTo: 'Publishing {type} to {platform}...',
    successTitle: 'Congratulations!',
    successMessage: 'Your post has been published successfully!',
    successMessageWithType: 'Your {type} has been published successfully!',
    partialSuccessTitle: 'Partially Published',
    errorTitle: 'Publishing Failed',
    errorMessage: 'Failed to publish to any platform.',
    createAnother: 'Create Another Post'
  },

  // Carousel Content
  carousel: {
    generateContentTitle: 'Customize Carousel Content',
    generating: 'Generating content...',
    selectedImages: 'Selected Images',
    caption: 'Caption',
    captionPlaceholder: 'Write your carousel caption...',
    hashtags: 'Hashtags (one per line)',
    hashtagsPlaceholder: '#food\n#brand\n#delicious',
    hashtagsHint: 'Enter one hashtag per line',
    regenerate: 'Regenerate Content',
    useContent: 'Use This Content',
    wizardTitle: 'Create Carousel Post',
    step1Title: 'Select Images',
    step2Title: 'Customize Content',
    nextStep: 'Next',
    previousStep: 'Back'
  },

  // Sidebar Navigation
  sidebar: {
    menu: 'Menu',
    dashboard: 'Dashboard',
    content: 'Posts',
    calendar: 'Schedule',
    analytics: 'Analytics',
    platforms: 'Platforms',
    creditsUsed: 'Credits Used',
    upgrade: 'Upgrade',
    profile: 'Profile',
    logout: 'Logout',
    notifications: 'Notifications',
    referFriend: 'Refer a Friend',
    unlimited: 'Unlimited',
    unlimitedCredits: 'Unlimited'
  },

  // New Dashboard Elements
  dashboardNew: {
    settings: 'Settings',
    recentPosts: 'Recent Posts',
    viewAll: 'View All',
    viewCalendar: 'View Calendar',
    manageSaved: 'Manage Saved',
    openSettings: 'Open Settings',
    noRecentPosts: 'No posts yet',
    createFirstPost: 'Create Your First Post',
    post: 'Post',
    status: 'Status',
    platforms: 'Platforms',
    activeCount: 'Active',
    allRestaurants: 'All Brands',
    restaurant: 'Brand',
    published: 'Published',
    scheduled: 'Scheduled',
    failed: 'Failed',
    partial: 'Partially Published',
    cancelled: 'Cancelled',
    draft: 'Draft',
    creditsLeft: 'credits left',
    tierLifetimeDesc: 'Unlimited access forever',
    tierYearlyDesc: 'Best value, billed annually',
    tierMonthlyDesc: 'Flexible monthly billing'
  },

  // Dashboard Redesign
  dashboardRedesign: {
    goodMorning: 'Good morning, {name}',
    goodAfternoon: 'Good afternoon, {name}',
    goodEvening: 'Good evening, {name}',
    heroSubtitle: 'Here\'s what\'s happening with your content today',
    createContent: 'Create Content',
    totalPosts: 'Total Posts',
    scheduledLabel: 'Scheduled',
    savedContent: 'Saved Content',
    creditsLabel: 'Credits Left',
    untitledPost: 'Untitled post',
    today: 'Today',
    tomorrow: 'Tomorrow',
    engagementSnapshot: 'Engagement Snapshot',
    viewAnalytics: 'View Analytics',
    upcomingPosts: 'Upcoming Posts',
    viewCalendar: 'View Calendar',
    noUpcomingTitle: 'No upcoming posts',
    noUpcomingDesc: 'Schedule your first post to see it here',
    scheduleFirst: 'Schedule a Post',
    recentActivity: 'Recent Activity',
    viewAllPosts: 'View All Posts',
    noActivityTitle: 'No recent activity',
    noActivityDesc: 'Create your first post to get started'
  },

  // Privacy Policy
  privacy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last updated: December 5th 2025',
    sections: {
      introduction: {
        title: '1. Introduction',
        content:
          'Welcome to SocialChef ("we," "our," or "us"). We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our AI-powered social media management platform.'
      },
      informationWeCollect: {
        title: '2. Information We Collect',
        intro: 'We collect the following types of information:',
        items: {
          accountInfo:
            'Account Information: Name, email address, password, and profile details when you create an account.',
          socialMedia:
            'Social Media Data: When you connect your social media accounts (Facebook, Instagram, etc.), we access the data necessary to post content on your behalf, including page information and posting permissions.',
          content:
            'Content Data: Images, captions, hashtags, and other content you create or upload through our platform.',
          usage:
            'Usage Information: How you interact with our platform, including features used, posts created, and scheduling preferences.',
          device:
            'Device Information: Browser type, IP address, device identifiers, and operating system for security and analytics purposes.'
        }
      },
      howWeUse: {
        title: '3. How We Use Your Information',
        intro: 'We use your information to:',
        items: {
          provideService:
            'Provide and operate our AI-powered content generation and social media management services.',
          improveService:
            'Improve and personalize your experience, including training our AI models to better serve your content needs.',
          communicate:
            'Send you service-related communications, updates, and marketing materials (with your consent).',
          security:
            'Ensure the security of our platform and protect against fraud or unauthorized access.',
          legal: 'Comply with legal obligations and enforce our terms of service.'
        }
      },
      dataSharing: {
        title: '4. Data Sharing and Disclosure',
        intro: 'We may share your information with:',
        items: {
          socialPlatforms:
            'Social Media Platforms: To publish content on your connected accounts (Facebook, Instagram, etc.).',
          serviceProviders:
            'Service Providers: Third-party vendors who help us operate our platform (hosting, analytics, payment processing).',
          legal: 'Legal Requirements: When required by law, court order, or government request.',
          businessTransfer:
            'Business Transfers: In connection with a merger, acquisition, or sale of assets.'
        },
        noSelling: 'We do not sell your personal information to third parties.'
      },
      dataSecurity: {
        title: '5. Data Security',
        content:
          'We implement industry-standard security measures to protect your information, including encryption, secure servers, and regular security audits. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.'
      },
      dataRetention: {
        title: '6. Data Retention',
        content:
          'We retain your personal information for as long as your account is active or as needed to provide you services. You may request deletion of your data at any time by contacting us or through your account settings.'
      },
      yourRights: {
        title: '7. Your Rights',
        intro: 'Depending on your location, you may have the following rights:',
        items: {
          access: 'Access: Request a copy of the personal information we hold about you.',
          correction: 'Correction: Request correction of inaccurate or incomplete information.',
          deletion: 'Deletion: Request deletion of your personal information.',
          portability: 'Portability: Request a copy of your data in a portable format.',
          withdraw:
            'Withdraw Consent: Withdraw consent for processing where consent is the legal basis.'
        },
        contact: 'To exercise these rights, please contact us at the email address below.'
      },
      cookies: {
        title: '8. Cookies and Tracking',
        content:
          'We use cookies and similar technologies to improve your experience, analyze usage, and personalize content. You can control cookie preferences through your browser settings. Some features may not function properly if cookies are disabled.'
      },
      thirdParty: {
        title: '9. Third-Party Links',
        content:
          'Our platform may contain links to third-party websites or services. We are not responsible for the privacy practices of these external sites. We encourage you to review their privacy policies before providing any personal information.'
      },
      children: {
        title: "10. Children's Privacy",
        content:
          'Our services are not intended for individuals under 18 years of age. We do not knowingly collect personal information from children. If you believe we have collected information from a child, please contact us immediately.'
      },
      changes: {
        title: '11. Changes to This Policy',
        content:
          'We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy on our platform and updating the "Last Updated" date. Your continued use of our services after changes constitutes acceptance of the updated policy.'
      },
      contact: {
        title: '12. Contact Us',
        content:
          'If you have questions about this Privacy Policy or our data practices, please contact us at:'
      }
    }
  },

  // Terms of Service
  terms: {
    title: 'Terms of Service',
    lastUpdated: 'Last updated: December 5th 2025',
    sections: {
      acceptance: {
        title: '1. Acceptance of Terms',
        content:
          'By accessing or using SocialChef ("Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our Service. These Terms apply to all users, including visitors, registered users, and subscribers.'
      },
      description: {
        title: '2. Description of Service',
        content:
          'SocialChef is an AI-powered social media management platform. Our Service enables you to generate marketing content, create images and captions, schedule posts, and publish content to connected social media platforms. Features may vary based on your subscription plan.'
      },
      eligibility: {
        title: '3. Eligibility',
        content:
          'You must be at least 18 years old and capable of forming a binding contract to use our Service. By using SocialChef, you represent and warrant that you meet these eligibility requirements.'
      },
      account: {
        title: '4. Account Registration and Security',
        intro: 'To use certain features, you must create an account. You agree to:',
        items: {
          accurate: 'Provide accurate, current, and complete information during registration.',
          security: 'Maintain the security of your password and account credentials.',
          notify: 'Notify us immediately of any unauthorized access or security breach.',
          responsible: 'Accept responsibility for all activities that occur under your account.'
        }
      },
      acceptableUse: {
        title: '5. Acceptable Use Policy',
        intro: 'You agree not to use the Service to:',
        items: {
          illegal: 'Violate any applicable laws, regulations, or third-party rights.',
          harmful: 'Upload or distribute harmful, offensive, or inappropriate content.',
          infringe: 'Infringe on intellectual property rights of others.',
          spam: 'Send spam, unsolicited messages, or engage in deceptive practices.',
          interfere: 'Interfere with or disrupt the Service or its infrastructure.',
          impersonate: 'Impersonate any person or entity or misrepresent your affiliation.',
          reverse:
            'Attempt to reverse engineer, decompile, or extract source code from our Service.'
        }
      },
      content: {
        title: '6. User Content',
        ownership:
          'You retain ownership of any content you create or upload to SocialChef. However, by using our Service, you grant us a limited license to use, store, and process your content solely for the purpose of providing the Service.',
        license:
          'For AI-generated content created through our platform, you receive a license to use such content for your brand purposes, subject to any restrictions in your subscription plan.',
        responsibility:
          'You are solely responsible for ensuring that your content complies with applicable laws and does not infringe on third-party rights.'
      },
      socialMedia: {
        title: '7. Social Media Integration',
        content:
          'When you connect third-party social media accounts, you authorize us to access and interact with those accounts on your behalf. You are responsible for complying with the terms of service of each connected platform. We are not liable for any actions taken by or restrictions imposed by third-party platforms.'
      },
      subscription: {
        title: '8. Subscription and Payment',
        billing:
          'Paid subscriptions are billed according to the plan you select. All fees are non-refundable unless otherwise stated or required by law.',
        cancellation:
          'You may cancel your subscription at any time through your account settings. Cancellation takes effect at the end of the current billing period.',
        changes:
          'We reserve the right to change our pricing with reasonable notice. Continued use after price changes constitutes acceptance of new pricing.'
      },
      intellectual: {
        title: '9. Intellectual Property',
        content:
          'SocialChef and its original content, features, and functionality are owned by us and protected by international copyright, trademark, and other intellectual property laws. Our AI technology, algorithms, and platform design remain our exclusive property.'
      },
      disclaimer: {
        title: '10. Disclaimer of Warranties',
        content:
          'THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE. AI-GENERATED CONTENT MAY CONTAIN ERRORS OR INACCURACIES, AND YOU ARE RESPONSIBLE FOR REVIEWING ALL CONTENT BEFORE PUBLICATION.'
      },
      limitation: {
        title: '11. Limitation of Liability',
        content:
          'TO THE MAXIMUM EXTENT PERMITTED BY LAW, SOCIALCHEF SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING LOSS OF PROFITS, DATA, OR BUSINESS OPPORTUNITIES, ARISING FROM YOUR USE OF THE SERVICE.'
      },
      indemnification: {
        title: '12. Indemnification',
        content:
          'You agree to indemnify and hold harmless SocialChef, its officers, directors, employees, and agents from any claims, damages, losses, or expenses arising from your use of the Service, violation of these Terms, or infringement of any third-party rights.'
      },
      termination: {
        title: '13. Termination',
        content:
          'We may suspend or terminate your access to the Service at any time for violation of these Terms or for any other reason at our discretion. Upon termination, your right to use the Service ceases immediately, though certain provisions of these Terms will survive.'
      },
      changes: {
        title: '14. Changes to Terms',
        content:
          'We reserve the right to modify these Terms at any time. We will notify users of material changes by posting the updated Terms on our platform. Your continued use of the Service after changes constitutes acceptance of the modified Terms.'
      },
      governing: {
        title: '15. Governing Law',
        content:
          'These Terms shall be governed by and construed in accordance with the laws of Norway, without regard to its conflict of law provisions. Any disputes arising from these Terms shall be resolved in the courts of Norway.'
      },
      contact: {
        title: '16. Contact Information',
        content: 'For questions about these Terms of Service, please contact us at:'
      }
    }
  },

  // Inline Feedback
  feedback: {
    inlineTitle: 'Help us improve',
    inlineSubtitle: "This won't be included in your post",
    whatDidYouLike: 'What did you like or dislike about this post?',
    feedbackPlaceholder: 'Share what worked well or what could be better...'
  },

  // Contact Feedback
  contactFeedback: {
    modalTitle: 'Send us your feedback',
    description: "Have a question, suggestion, or issue? We'd love to hear from you!",
    messageLabel: 'Your Message',
    messagePlaceholder: 'Share your thoughts, suggestions, or issues...',
    characterCount: '{count}/2000',
    cancel: 'Cancel',
    send: 'Send Feedback',
    sending: 'Sending...',
    successMessage: "Thank you for your feedback! We've received your message and will get back to you soon.",
    errorRequired: 'Please enter a message',
    errorFailed: 'Failed to send feedback. Please try again.',
    buttonLabel: 'Feedback',
    buttonAriaLabel: 'Send Feedback'
  },

  // Contact Page
  contact: {
    title: 'Get in Touch',
    subtitle: 'Have a question or want to learn more? We\'d love to hear from you.',
    nameLabel: 'Name',
    namePlaceholder: 'Your name',
    emailLabel: 'Email',
    emailPlaceholder: 'Your email address',
    subjectLabel: 'Subject',
    subjectPlaceholder: 'Select a subject',
    messageLabel: 'Message',
    messagePlaceholder: 'Tell us what\'s on your mind...',
    submit: 'Send Message',
    successTitle: 'Message Sent!',
    successMessage: 'Thank you for reaching out. We\'ll get back to you as soon as possible.',
    error: 'Something went wrong. Please try again later.',
    orEmail: 'Or email us directly',
    subjects: {
      general: 'General Inquiry',
      support: 'Support',
      partnership: 'Partnership',
      feedback: 'Feedback'
    }
  },

  // Generating Progress
  generatingProgress: {
    title: 'Creating your post',
    hint: 'This usually takes 20-50 seconds',
    steps: {
      analyzing: 'Analyzing',
      designing: 'Designing',
      generating: 'Generating',
      refining: 'Refining',
      finalizing: 'Finalizing'
    }
  },

  // Delete Account Page
  deleteAccount: {
    pageTitle: 'Delete Your Account',
    warning: 'Warning: This action cannot be undone',

    // Step 1 - Warning
    step1Title: 'Are you sure?',
    step1Description: 'Deleting your account will permanently remove all your data. This includes:',
    dataList: {
      restaurants: 'All saved brands and their settings',
      posts: 'All generated posts and images',
      favorites: 'All saved favorites and scheduled posts',
      connections: 'All connected social media accounts',
      subscription: 'Your subscription (will be cancelled immediately)',
      history: 'All usage history and analytics'
    },

    // Step 2 - Confirmations
    step2Title: 'Confirm you understand',
    confirmDataLoss: 'I understand that all my data will be permanently deleted',
    confirmNoRecovery: 'I understand that my account cannot be recovered after deletion',
    confirmImmediateEffect:
      'I understand that deletion takes effect immediately and I will be logged out',

    // Step 3 - Type DELETE

    // Reason
    reasonTitle: 'Help us improve (optional)',
    reasonDescription: "Please let us know why you're leaving:",
    reasonPlaceholder: 'What could we have done better?',

    // Buttons
    continueButton: 'Continue',
    backButton: 'Go Back',
    cancelButton: 'Cancel',
    deleteButton: 'Delete My Account',
    deleting: 'Deleting...',

    // Final modal

    // Success/Goodbye
    goodbyeTitle: 'Goodbye!',
    goodbyeMessage: "Your account has been successfully deleted. We're sorry to see you go.",
    goodbyeSubtext: "If you ever want to come back, you're always welcome to create a new account.",
    returnToHome: 'Return to Home',

    // Errors
    errorGeneric: 'An error occurred while deleting your account. Please try again.'
  },

  // Analytics Page
  analytics: {
    title: 'Analytics',
    subtitle: 'Track your content performance and growth',
    days: 'Days',
    allTime: 'All Time',

    // Metrics
    totalPosts: 'Total Posts',
    postsCreated: 'Posts Created',
    savedPosts: 'Saved Content',
    scheduledPosts: 'Scheduled',
    publishedPosts: 'Published',

    // Charts
    postingActivity: 'Posting Activity',
    postsOverTime: 'Posts scheduled and published over time',
    postsActivity: 'Posts',
    platformDistribution: 'Platform Distribution',
    postsByPlatform: 'Posts breakdown by social platform',
    postStatus: 'Post Status',
    byStatus: 'Overview of all scheduled posts',

    // Status labels
    published: 'Published',
    scheduled: 'Scheduled',
    cancelled: 'Cancelled',
    failed: 'Failed',
    pending: 'Pending',
    draft: 'Draft',
    allStatuses: 'All',

    // Platform tabs
    allPlatforms: 'All Platforms',
    platformFilter: 'Filter by Platform',
    selectedPlatform: 'Selected Platform',
    showingDataFor: 'Showing data for {platform}',
    noPlatformPosts: 'No {platform} posts yet',
    noPlatformPostsDesc: 'Create and schedule posts for this platform to see analytics here',
    createPost: 'Create Post',

    // Usage
    usageOverview: 'Usage Overview',
    monthlyUsage: 'Your current billing cycle',
    creditsUsed: 'Credits Used',
    used: 'used',
    subscription: 'Subscription',
    restaurants: 'Brands',

    // Recent Activity
    recentActivity: 'Recent Activity',
    latestPosts: 'Your latest scheduled posts',
    noText: 'No text content',
    noRecentActivity: 'No recent activity to show',
    noDataYet: 'No data available yet',
    postImage: 'Post image',
    viewOn: 'View on {platform}',

    // Table headers
    post: 'Post',
    platforms: 'Platforms',
    restaurant: 'Brand',
    status: 'Status',
    date: 'Date',
    links: 'Links',
    video: 'Video',
    errorReason: 'Error',
    unknownError: 'Post failed to publish. Please try again or contact support.',

    // Pagination
    page: 'Page',
    of: 'of',

    // Post Modal
    postDetails: 'Post Details',
    postContent: 'Post Content',
    viewOnPlatforms: 'View on Platforms',

    // Empty State
    emptyStateTitle: 'Time to create some posts!',
    emptyStateDescription:
      "Once you start creating and scheduling content, your analytics will appear here. Let's get started!",
    createFirstPost: 'Create Your First Post',

    // Engagement metrics
    engagement: 'Engagement',
    likes: 'Likes',
    comments: 'Comments',
    shares: 'Shares',
    reach: 'Reach',
    views: 'Views (Reach)',
    impressions: 'Impressions',
    engagementRate: 'Engagement Rate',
    totalEngagement: 'Total Engagement',
    averageEngagement: 'Average Engagement',
    averageEngagementRate: 'Average Engagement Rate',
    topPerformingPosts: 'Top Performing Posts',
    topPerforming: 'Top Performing Posts',
    highestEngagement: 'Posts with highest engagement rate',
    performance: 'Performance',
    noPerformanceData: 'Publish posts and sync metrics to see top performers',
    viewsTooltip: 'Total reach across all platforms',
    engagementOverTime: 'Engagement Over Time',

    // Reach/impressions data info
    reachDataLimited: 'Views & Reach Data Limited',
    reachDataInfo: 'Views (reach/impressions) require Business accounts with Insights API permissions. Personal accounts only show likes, comments, and shares. To see views data, connect a Business or Creator account with proper permissions.',
    reachDataUnavailable: 'Views data requires Business account permissions',

    // Instagram views info (legacy)
    instagramViewsLimited: 'Instagram Views Limited',
    instagramViewsInfo: 'Instagram views require Instagram Business account with Insights API permission. Currently showing likes and comments only.',
    learnMore: 'Learn More',

    // Engagement syncing
    engagementSyncing: 'Syncing engagement data...',
    detailedBreakdown: 'Detailed Breakdown',
    chartsAndDistributions: 'Charts and distributions for your content',

    // Sync status
    syncStatus: 'Sync Status',
    syncing: 'Syncing...',
    lastUpdated: 'Last updated {time}',
    refreshMetrics: 'Refresh Metrics',
    refreshing: 'Refreshing...',
    lastSynced: 'Last synced',
    notSynced: 'Engagement not synced yet',

    // Time relative
    justNow: 'Just now',
    oneMinuteAgo: '1 minute ago',
    minutesAgo: '{minutes} minutes ago',
    oneHourAgo: '1 hour ago',
    hoursAgo: '{hours} hours ago',
    oneDayAgo: '1 day ago',
    daysAgo: '{days} days ago',

    // Errors and messages
    noEngagementData: 'No engagement data available. Click "Refresh Metrics" to sync from social platforms.',
    engagementUnavailable: 'Engagement metrics unavailable',
    syncError: 'Failed to sync metrics',
    reconnectRequired: 'Reconnect {platform} to view insights',
    noPublishedPosts: 'No published posts yet. Publish posts to see engagement metrics!',
    engagementNotSynced: 'Engagement data not synced yet. Click "Refresh Metrics" to sync from social platforms.',
    engagementFetchFailed: 'Failed to fetch engagement data. Please try refreshing.',
    engagementError: 'Error loading engagement data. Please check console for details.',
    refreshSuccess: 'Successfully refreshed {count} post',
    refreshFailed: 'Failed to refresh engagement data. The backend may not be syncing from social platforms yet.',
    refreshError: 'Error refreshing engagement data'
  },

  // Referral Program
  referral: {
    // Landing Page
    landingTitle: "You've Been Invited!",
    landingSubtitle: 'Your friend thinks you\'ll love Social Chef',
    benefitsTitle: 'Your Exclusive Benefits',
    freeMonth: 'First Month FREE',
    freeMonthDesc: 'Start with 30 days completely free',
    fiftyOff: '50% Off for 2 Months',
    fiftyOffDesc: 'After your free month, pay half price for months 2-3',
    fullAccess: 'Full Access',
    fullAccessDesc: 'Enjoy all premium features from day one',
    getStarted: 'Get Started Now',
    invalidCode: 'Invalid referral code',
    invalidCodeTitle: 'Invalid Invitation',
    invalidCodeMessage: 'This referral code is no longer valid. You can still sign up at full price.',
    noCodeTitle: 'No Referral Code',
    noCodeDesc: 'It looks like you don\'t have a referral code. Ask a friend for their code or sign up directly.',
    goToHome: 'Go to Homepage',
    signUpAnyway: 'Sign Up Anyway',
    validatingCode: 'Validating your invitation...',
    validationError: 'Could not validate referral code. Please try again.',
    invitedBy: 'Invited by {name}',
    codeApplied: 'Referral code applied successfully!',
    applyError: 'Could not apply referral code. Please try again.',
    discountBadge: '1 Month FREE + 50% Off',
    ctaTitle: 'Ready to Get Started?',
    ctaDescription: 'Your discount will be automatically applied at checkout.',
    ctaNote: 'Create your account and your discount will be waiting for you',

    // Profile Section
    sectionTitle: 'Refer a Friend',
    yourCode: 'Your Referral Code',
    copyCode: 'Copy Code',
    copyLink: 'Copy Link',
    codeCopied: 'Code copied!',
    linkCopied: 'Link copied!',
    shareLink: 'Share Link',
    shareVia: 'Share via',
    share: 'Share',
    shareTitle: 'Join Social Chef',
    shareText: 'I\'ve been using Social Chef for my brand and love it! Sign up with my link to get your first month free + 50% off for 2 months.',
    shareEmailSubject: 'Join Social Chef - Get Your First Month Free!',

    // Stats
    stats: 'Referral Statistics',
    totalReferrals: 'Total Referrals',
    successfulReferrals: 'Successful',
    pendingReferrals: 'Pending',
    creditsEarned: 'Total Credits Earned',
    currentBalance: 'Current Balance',
    referralHistory: 'Referral History',
    noReferrals: 'No referrals yet. Share your code to start earning credits!',

    // Status Labels
    statusPending: 'Pending',
    statusConverted: 'Signed Up',
    statusCredited: 'Credited',
    statusExpired: 'Expired',

    // How It Works
    howItWorks: 'How It Works',
    step1Title: 'Share Your Code',
    step1Desc: 'Send your unique referral link to friends',
    step2Title: 'Friend Subscribes',
    step2Desc: 'They get a free month + 50% off for 2 months',
    step3Title: 'You Earn Credits',
    step3Desc: 'Get account credit equal to 50% of 2 months',

    // Errors
    requiresSubscription: 'Referral codes are available for active monthly or yearly subscribers',
    alreadyReferred: 'You have already used a referral code',
    cannotUsOwnCode: 'You cannot use your own referral code',
    codeNotFound: 'Referral code not found',
    codeInactive: 'This referral code is no longer active'
  },

  // Brand Filter
  brandFilter: {
    selectBrands: 'Select Brands',
    searchBrands: 'Search brands...',
    brandsSelected: '{count} brand selected | {count} brands selected',
    noBrandsFound: 'No brands found',
    tryDifferentSearch: 'Try a different search term',
    clearAll: 'Clear All',
    applyFilters: 'Apply Filters'
  },

  // Filter Bar
  filters: {
    title: 'Filters',
    clearAll: 'Clear All',
    platforms: 'Platforms',
    platformsCount: 'Platforms ({count})',
    brands: 'Brands',
    brandsCount: 'Brands ({count})',
    contentType: 'Content Type',
    contentTypeCount: 'Content Type ({count})',
    newestFirst: 'Newest First',
    oldestFirst: 'Oldest First',
    active: 'Active:',
    images: 'Images',
    videos: 'Videos'
  },

  // Post Type Selection
  postType: {
    label: 'Post Type',
    selectType: 'Post Type',
    feed: 'Feed Post',
    feedDesc: 'Regular post on timeline/profile',
    story: 'Story',
    storyDesc: '24-hour story (image or video)',
    storyExpiryNotice: 'Stories expire after 24 hours and may not have permanent links',
    reel: 'Reel',
    reelDesc: 'Short-form content (image or video)',
    carousel: 'Carousel',
    carouselDesc: '2-10 images/videos',
    notSet: 'Not Set',
    multiple: '{count} types'
  },

  // App Landing Page
  appLanding: {
    nav: {
      features: 'Features',
      pricing: 'Pricing',
      howItWorks: 'How It Works',
      getEarlyAccess: 'Get Early Access'
    },
    hero: {
      badge: 'Coming Soon to iOS & Android',
      headline: 'Your Autonomous Social Media Employee,',
      headlineAccent: 'in Your Pocket',
      subheadline: 'Built for business owners who\'d rather run their business than run their Instagram.',
      ctaPrimary: 'Get Early Access',
      ctaSecondary: 'See How It Works',
      floatingBadge1: 'Published to Instagram',
      proofQuote: 'SocialChef saved me 15 hours a week on content creation. It\'s like having a full marketing team.',
      proofAuthor: 'Taieb C.',
      proofRole: 'CEO, Hiring Platform'
    },
    builtFor: {
      eyebrow: 'Built For You',
      title: 'Designed for Businesses Like Yours',
      subtitle: 'Whether you run a restaurant, a car wash, or a growing startup — SocialChef handles your social media so you don\'t have to.',
      persona1Title: 'Restaurant & Hospitality',
      persona1Pain: 'Too busy in the kitchen to think about Instagram.',
      persona1Result: 'SocialChef posts mouth-watering content on autopilot.',
      persona2Title: 'Local Service Businesses',
      persona2Pain: 'Hands are always full — no time for social media.',
      persona2Result: 'Customers find you online without you lifting a finger.',
      persona3Title: 'Growing Startups',
      persona3Pain: 'Need a marketing presence but can\'t afford a team.',
      persona3Result: 'Professional social media presence from day one.',
      persona4Title: 'Multi-Location Brands',
      persona4Pain: 'Managing multiple brands across platforms is a nightmare.',
      persona4Result: 'One dashboard to manage all your brands effortlessly.'
    },
    socialProof: {
      platforms: 'Works with'
    },
    pricing: {
      eyebrow: 'Pricing',
      title: 'Simple, Transparent Pricing',
      subtitle: 'Choose the plan that fits your business. Save 50% with annual billing.',
      monthly: 'Monthly',
      annual: 'Annual',
      save: 'Save 50%',
      month: 'mo',
      year: 'yr',
      popular: 'Most Popular',
      cta: 'Get Early Access',
      pro: 'Pro',
      business: 'Business',
      yearlySavePro: 'Save $474/yr',
      yearlySaveBusiness: 'Save $894/yr',
      featureAiChat: 'AI chat & content creation',
      featurePlanning: 'Content planning & calendar',
      featurePublishing: 'Post management & publishing',
      featureAnalytics: 'Analytics & insights',
      featureDesign: 'Design studio',
      featureAds: 'Google, Facebook & Pinterest Ads',
      featureAssets: 'Asset management',
      featureTeam: 'Team collaboration',
      featureBrandVoice: 'Brand voice training',
      featureCompetitor: 'Competitor intelligence',
      featureMultiBrand: 'Multi-brand management',
      featureSupport: 'Support',
      supportEmail: 'Email',
      supportPriority: 'Priority'
    },
    aiCreation: {
      eyebrow: 'Smart Content Engine',
      title: 'Watch Your Content Come to Life',
      subtitle: 'From a simple prompt to published content — see the smart creation pipeline in action',
      promptTitle: 'AI-Powered Suggestions',
      promptDesc: 'SocialChef proactively creates post ideas based on your brand, audience, and trending topics.',
      promptGreeting: 'Hey! I put together a post idea for Jungel Pizza today. What do you think?',
      promptSuggestionCaption: 'Friday vibes & your best pizza yet — fresh from the stone oven',
      promptToneBadge: 'Professional',
      generateTitle: 'Smart Content Generation',
      generateDesc: 'SocialChef writes copy, selects images, and crafts platform-optimized posts.',
      adaptTitle: 'Multi-Platform Adapt',
      adaptDesc: 'Content is automatically tailored for each platform\'s format and best practices.',
      scheduleTitle: 'Schedule & Publish',
      scheduleDesc: 'Any platform, any time. Schedule feed posts, reels, stories, carousels and more — or let SocialChef pick the best time for your audience.',
      scheduleStageDesc: 'Any platform, any format, at the perfect time',
      badgeScheduled: 'Scheduled',
      badgePublished: 'Published',
      dayMon: 'Mon',
      dayTue: 'Tue',
      dayWed: 'Wed',
      dayThu: 'Thu',
      dayFri: 'Fri',
      postBrandName: 'Your Brand',
      postTimestamp: 'Just now',
      postTabFeed: 'Feed',
      postTabReel: 'Reel',
      postTabStory: 'Story',
      postTabCarousel: 'Carousel',
      postTabText: 'Text',
      adaptPublishAnywhere: 'Publish anywhere, any time',
      postToneBadge: 'Casual',
      postCaption: 'Friday vibes & your best pizza yet — fresh from the stone oven every weekend',
      postCaptionMore: 'Come try our new truffle pizza this Friday!',
      postPublishNow: 'Publish Now',
      postSchedule: 'Schedule',
      postEdit: 'Edit',
      postInputPlaceholder: 'Message...',
      // Tab labels
      promptTab: 'AI Suggests',
      generateTab: 'Generate Post',
      adaptTab: 'Adapt Platforms',
      scheduleTab: 'Schedule & Publish',
      // Step pills
      promptPill1: 'Brand voice',
      promptPill2: 'Trending topics',
      promptPill3: 'Audience data',
      generatePill1: 'AI copywriting',
      generatePill2: 'Hashtag AI',
      generatePill3: 'Multi-format',
      adaptPill1: 'Instagram',
      adaptPill2: 'Facebook',
      adaptPill3: 'LinkedIn',
      adaptPill4: 'TikTok',
      schedulePill1: 'Best-time AI',
      schedulePill2: 'All platforms',
      schedulePill3: 'Auto-publish',
      // Pause hint
      pauseHint: 'paused',
      // Adapt footer
      adaptFooter: 'Adapted for every platform, automatically',
      adaptChip1: 'Caption length',
      adaptChip2: 'Hashtag count',
      adaptChip3: 'Image crop',
      adaptChip4: 'Tone',
      // Calendar
      calTitle: 'Schedule & Publish',
      calSubtitle: 'AI picks the best time for your audience',
      // Chat actions
      chatUseThis: 'Use this',
      chatRegenerate: 'Regenerate',
      chatTyping: 'Love it! Schedule this for tomorrow on Facebook, Instagram, and LinkedIn',
      // Editor
      genEditorTitle: 'New Post — Jungel Pizza',
    },
    calendar: {
      eyebrow: 'Content Calendar',
      title: 'Your Entire Week, Planned',
      subtitle: 'Plan your week or month with your goals and brand focus messaging — all in one view.',
      thisWeek: 'This Week',
      autoSchedule: 'Auto-Schedule',
      autoScheduleDesc: 'AI picks the best times for each platform',
      multiPlatform: 'Multi-Platform',
      multiPlatformDesc: 'One calendar for all your social accounts',
      contentGoals: 'Content Goals',
      contentGoalsDesc: 'Set weekly themes and brand messaging targets',
      bulkImport: 'Bulk Import',
      bulkImportDesc: 'Import content plans from CSV or XLSX files',
      viewFull: 'View full calendar',
      weekSchedule: "This Week's Schedule",
      types: {
        feed: 'Feed',
        reel: 'Reel',
        story: 'Story',
        carousel: 'Carousel',
      },
      post1: 'New summer collection — fresh styles dropping...',
      post2: 'Our most popular service, now with a new...',
      post3: 'Top 5 things our customers loved this month...',
      post4: 'Behind the scenes at our studio today...',
      post5: 'Weekend special offers — book your spot...',
      post6: 'New arrivals just landed from our suppliers...',
    },
    adsManager: {
      eyebrow: 'Ads Manager',
      title: 'Run Ads Like a Pro. No Agency Needed.',
      subtitle: 'Create and manage Meta, Google, and X ads right from the app. Smart copy writing, targeting optimization, and automated reporting.',
      roas: 'ROAS',
      cpc: 'Avg. CPC',
      conversions: 'Conversions',
      spend: 'Total Spend',
      campaignTitle: 'Summer Collection Campaign',
      active: 'Active',
      impressions: 'Impressions',
      clicks: 'Clicks'
    },
    cinematic: {
      featureTitleChat: 'AI Chat Assistant',
      featureDescChat: 'Tell it what you need — it knows your brand.',
      featureTitleStrategy: 'Smart Content Strategy',
      featureDescStrategy: 'A full week of posts, planned in seconds.',
      featureTitleDesign: 'Built-In Design Studio',
      featureDescDesign: 'Edit visuals without leaving the app.',
      featureTitlePublish: 'One-Click Publishing',
      featureDescPublish: 'Post to every platform simultaneously.',
      featureTitleCalendar: 'Visual Content Calendar',
      featureDescCalendar: 'See your entire schedule at a glance.',
      featureTitleAnalytics: 'Real-Time Analytics',
      featureDescAnalytics: 'Track performance across all platforms.',
      featureTitleAds: 'Ad Campaign Manager',
      featureDescAds: 'Launch paid campaigns in minutes.',
      featureTitleCta: 'Ready to Start?',
      featureDescCta: 'Join businesses already saving hours each week.',
      ctaPhoneHeadline: 'What are you waiting for?',
      ctaPhoneSubtext: 'It won\'t publish itself without SocialChef.',
      ctaPhoneButton: 'Get Started',
      chatAiGreeting: 'Hi! I analyzed your brand. Ready to create content that matches your voice?',
      chatUserReply1: 'Love it! Plan my week across all platforms',
      chatAiStrategy: 'Here\'s your optimized content plan for Vetted this week:',
      chatCalendarTitle: 'Weekly Content Plan',
      planMonDay: 'Mon',
      planMonDesc: 'Thought leadership article',
      planWedDay: 'Wed',
      planWedDesc: 'Team culture behind-the-scenes',
      planFriDay: 'Fri',
      planFriDesc: 'Product feature spotlight',
      chatCalendarCount: '3 posts optimized per platform',
      chatUserReply2: 'Perfect — publish the thought leadership post now!',
      chatInputPlaceholder: 'Message...',
      attachTakePhoto: 'Take Photo',
      attachChooseAssets: 'Choose from Assets',
      attachDesignStudio: 'Design Studio',
      designTitle: 'Design Studio',
      designCropBg: 'Crop BG',
      designRatio: 'Ratio',
      designText: 'Text',
      designDraw: 'Draw',
      designCta: 'CTA',
      designOverlayText: 'The Future of Hiring',
      designPrompt: 'Add our brand gradient and clean typography',
      publishWhere: 'Where would you like to publish?',
      publishCaption: 'How We Grew 340% in Q1: The Strategy Behind the Numbers',
      publishHashtag1: '#Web3',
      publishHashtag2: '#FutureOfWork',
      publishFeed: 'Feed',
      publishStory: 'Story',
      publishCarousel: 'Carousel',
      publishNow: 'Publish Now',
      publishSchedule: 'Schedule',
      publishSuccess: 'Published!',
      analyticsTitle: 'Analytics',
      analyticsOverview: 'Overview',
      analyticsImpressions: 'Impressions',
      analyticsReach: 'Reach',
      analyticsEngagement: 'Engagement',
      analyticsClicks: 'Clicks',
      analyticsPublished: 'Published',
      analyticsPosts: 'Posts',
      analyticsTotalSpend: 'Total Spend',
      analyticsCtr: 'CTR',
      analyticsPerformanceTrend: 'Performance Trend',
      analyticsOrganic: 'Organic',
      analyticsPaid: 'Paid',
      analytics7Days: '7 Days',
      analytics30Days: '30 Days',
      analytics90Days: '90 Days',
      analyticsChartTitle: 'Engagement Over Time',
      analyticsPlatformTitle: 'Platform Performance',
      calTitle: 'Calendar',
      calBrand: 'Vetted',
      calMonth: 'March 2026',
      calSelectedDay: 'Wednesday, March 25',
      calPostTitle: 'Personalized Interaction',
      calPostPlatform: 'Facebook',
      calPostStatus: 'Scheduled 10:00',
      calPost2Title: 'Summer Vibes Collection',
      calPost2Platform: 'Instagram',
      calPost2Status: 'Scheduled 14:00',
      adsCreateTitle: 'Create Campaign',
      adsPlatformLabel: 'Platform',
      adsObjectiveLabel: 'Objective',
      adsObjectiveReach: 'Reach',
      adsObjectiveEngagement: 'Engagement',
      adsObjectiveClicks: 'Clicks',
      adsBudgetLabel: 'Daily Budget',
      adsDurationLabel: 'Duration',
      adsBudgetValue: '250 kr / day',
      adsDurationValue: '7 days',
      adsLaunch: 'Launch Campaign',
      adsSuccessTitle: 'Campaign Created!',
      adsEstReach: 'Est. Reach',
      adsTotalBudget: 'Total Budget',
      adsEstCtr: 'Est. CTR',
      publishCardIntro: "Here's your post, ready to go:",
      publishedBadge: 'Published',
      publishedDate: 'Tue, 17 March · 20:41',
      publishedAgo: '1d ago',
      publishedAccount: 'SocialChef',
      publishedFeedLink: 'Feed',
      publishedMoreLikeThis: 'More like this',
      publishedLessLikeThis: 'Less like this',
    },
    featureShowcase: {
      eyebrow: 'SMART CONTENT ENGINE',
      title: 'Watch Your Content Come to Life',
      subtitle: 'From a simple prompt to published content — see the smart creation pipeline in action.',
      tabAnalytics: 'Analytics',
      tabCalendar: 'Calendar',
      tabCompetitor: 'Competitor Intel',
      tabDesignBuilder: 'Design Builder',
      tabAds: 'Ads Manager',
      tabAI: 'AI Assistant',
      tabPublishing: 'Publishing',
    },
    designBuilder: {
      eyebrow: 'Design Builder',
      title: 'Create Scroll-Stopping Visuals',
      subtitle: 'In-app design canvas for social creatives. Templates, brand colors, smart image generation — all in one place.',
      background: 'Background',
      backgroundDesc: 'Gradients, colors, or generated scenes',
      image: 'Image Layer',
      imageDesc: 'Generated or uploaded media',
      text: 'Text Overlay',
      textDesc: 'Headlines, captions, and CTAs',
      video: 'Video Generation',
      videoDesc: 'AI-powered video from text or images',
      branding: 'Brand Kit',
      brandingDesc: 'Logo, colors, and fonts auto-applied',
      tploceanName: 'Ocean',
      tploceanEyebrow: 'Smart Social Media',
      tploceanHeadline: 'Your Content, on Autopilot',
      tploceanSubline: 'Creates, schedules, and publishes — autonomously, 24/7',
      tplcoastalName: 'Coastal',
      tplcoastalEyebrow: 'Design Builder',
      tplcoastalHeadline: 'Scroll-Stopping Visuals',
      tplcoastalSubline: 'Templates, brand colors, and smart generation in one place',
      tplpremiumName: 'Premium',
      tplpremiumEyebrow: 'Brand Identity',
      tplpremiumHeadline: 'Elevate Your Brand Presence',
      tplpremiumSubline: 'Luxury templates with your colors, fonts, and logo built in',
      formatimage: 'Image',
      formatvideo: 'Video',
      formatcarousel: 'Carousel',
      designCafeBrand: 'The Corner Café',
      designCafeHeadline: 'Fresh Summer Menu',
      designCafeSubline: 'New seasonal dishes — book your table today',
      designSalonBrand: 'Glow Studio',
      designSalonHeadline: 'Transform Your Look',
      designSalonSubline: 'Watch our latest styling tutorial',
      designRetailBrand: 'Urban Threads',
      designRetailHeadline: 'New Arrivals Drop',
      designRetailSubline: 'Swipe through this week\'s collection'
    },
    analytics: {
      eyebrow: 'Analytics Dashboard',
      title: 'Know What\'s Working',
      subtitle: 'Track performance across all platforms with real-time analytics and smart insights.',
      followers: 'Followers',
      engagement: 'Engagement',
      reach: 'Reach',
      posts: 'Posts',
      chartTitle: 'Engagement Rate',
      chartPeriod: 'Last 7 days'
    },
    competitor: {
      eyebrow: 'Competitor Intelligence',
      title: 'Stay Ahead of the Competition',
      subtitle: 'Monitor competitor activity, benchmark your performance, and discover content gaps.',
      dashTitle: 'Competitor Dashboard',
      followers: 'Followers',
      engagement: 'Engagement',
      postsMonth: 'Posts/mo',
      benchmarking: 'Benchmarking',
      benchmarkingDesc: 'Compare your metrics side-by-side with competitors',
      contentGaps: 'Content Gaps',
      contentGapsDesc: 'Discover topics your competitors cover that you don\'t',
      trendAlerts: 'Trend Alerts',
      trendAlertsDesc: 'Get notified when competitors change strategy',
      shareOfVoice: 'Share of Voice',
      shareOfVoiceDesc: 'Track your brand\'s visibility vs the competition'
    },
    aiAssistant: {
      eyebrow: 'AI Assistant',
      title: 'Your Creative Partner, On Call 24/7',
      subtitle: 'Describe what you need and let AI create on-brand posts, images, and videos — with your voice, colors, and style built in.',
      smartCreation: 'Smart Creation',
      smartCreationDesc: 'Describe what you want, AI creates it',
      brandVoice: 'Brand Voice Match',
      brandVoiceDesc: 'Content matches your unique tone automatically',
      multiFormat: 'Multi-Format Output',
      multiFormatDesc: 'Posts, stories, reels, and carousels from one prompt',
      refinement: 'Iterate & Polish',
      refinementDesc: 'Refine until it\'s perfect, AI learns your preferences',
      userPrompt: 'What should I post this week? I want to grow engagement.',
      aiResponse: 'Based on your analytics, Reels are driving 3x more reach. I suggest a mix: 2 Reels, 1 carousel, and 1 story poll.',
      aiGenerated: 'I\'ve drafted all 4 posts with captions, hashtags, and image concepts — ready for your review.',
      userReply: 'Love it — schedule the Reels for Tuesday and Thursday',
      aiConfirm: 'Done! Reels scheduled at optimal times. I\'ll auto-publish to Instagram, TikTok, and Facebook.',
    },
    publishing: {
      eyebrow: 'Multi-Platform Publishing',
      title: 'One Click. Every Platform.',
      subtitle: 'Publish to Facebook, Instagram, TikTok, X, LinkedIn, and Pinterest simultaneously — each post auto-optimized per platform.',
      oneClick: 'One-Click Publish',
      oneClickDesc: 'Send to all platforms simultaneously',
      platformOptimize: 'Platform Optimization',
      platformOptimizeDesc: 'Auto-adjusts format, hashtags, and length per platform',
      sixPlatforms: '6+ Platforms',
      sixPlatformsDesc: 'Facebook, Instagram, TikTok, X, LinkedIn, Pinterest',
      smartTiming: 'Smart Timing',
      smartTimingDesc: 'AI picks the optimal posting time per platform',
      postTitle: 'Summer Menu Launch',
      sent: 'Sent',
      optimized: 'Optimized',
    },
    testimonials: {
      eyebrow: 'Testimonials',
      title: 'Loved by SMEs Everywhere',
      subtitle: 'See what early adopters are saying about SocialChef.',
      testimonial1: 'SocialChef saved me 15 hours a week on content creation. It actually understands my brand voice — it\'s like having a full marketing team.',
      testimonial2: 'The autopilot feature is incredible. I set it up once and my social accounts have been growing on their own for months.',
      testimonial3: 'Managing 5 brands used to be a nightmare. Now I do it all from one dashboard in 30 minutes a day.',
      testimonial4: 'As a business owner, I never had time for social media. SocialChef handles everything — from professional posts to seasonal promotions. My online bookings have doubled.',
      testimonial5: 'Running a car wash means my hands are always full. SocialChef keeps our social media active with zero effort. Customers tell me they found us through Instagram now.',
      decentralizedHiringCeo: 'CEO, Decentralized Hiring Platform',
      orderingPlatformCeo: 'CEO, Ordering Platform',
      resortOwner: 'Resort Owner',
      businessOwner: 'Business Owner',
      luxCarWashOwner: 'Owner, Lux Bilpleie'
    },
    earlyBird: {
      inputPlaceholder: 'Enter your email',
      cta: 'Claim My Early Access',
      successTitle: "You're in!",
      successMessage: "We'll notify you at launch.",
      noCreditCard: 'No credit card required',
      alreadyOnList: "You're already on the waitlist!",
      invalidEmail: 'Please enter a valid email address',
      error: 'Something went wrong. Please try again.'
    },
    finalCta: {
      title: "Ready to Automate Your Social Media?",
      subtitle: 'Join marketers who are getting early access to SocialChef.',
      cta: 'Get Early Access',
      proofQuote: 'My online bookings have doubled since I started using SocialChef.',
      proofAuthor: 'Peter',
      proofRole: 'Business Owner'
    },
    footer: {
      copyright: '© {year} SocialChef. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      contact: 'Contact'
    }
  }
}
